import { Button, MessageBar, MessageBarBody, Spinner } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from '../auth/oidc';

// Module-level: React 18 StrictMode runs effects twice in dev, and the authorization code is
// single-use, so a second signinRedirectCallback would fail and show a bogus error.
let pending: Promise<string> | null = null;

function safeReturnTo(state: unknown): string {
  const r = (state as { returnTo?: unknown } | undefined)?.returnTo;
  // Same-origin paths only; "//host" would be an open redirect.
  return typeof r === 'string' && r.startsWith('/') && !r.startsWith('//') ? r : '/';
}

export function Callback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    pending ??= userManager.signinRedirectCallback().then((u) => safeReturnTo(u.state));
    pending.then(
      (to) => navigate(to, { replace: true }),
      (e: unknown) => {
        pending = null;
        setError(e instanceof Error ? e.message : 'Sign-in failed.');
      },
    );
  }, [navigate]);

  if (error) {
    return (
      <MessageBar intent="error">
        <MessageBarBody>
          Sign-in failed: {error}{' '}
          <Button appearance="transparent" size="small" onClick={() => navigate('/', { replace: true })}>
            Back to start
          </Button>
        </MessageBarBody>
      </MessageBar>
    );
  }
  return <Spinner label="Signing you in" />;
}
